import React from "react";
import {
  FormSection,
  SectionTitle,
  FormGroup,
  Label,
  Input,
  ErrorMessage,
  OrderSummary as OrderSummaryStyled,
  SummaryRow,
  ActionButtons,
  ActionButton,
  ButtonContent,
  LoadingSpinner
} from "../../styles/OrderFormStyles";

const OrderSummary = ({
  formData,
  errors,
  loading,
  calculateTotal,
  handleSubmit,
  navigate,
  editMode,
  handleInputChange
}) => {
  return (
    <FormSection>
      <SectionTitle>Order Request Summary</SectionTitle>

      <FormGroup className="inline">
        <div>
          <Label htmlFor="shippingFee">Shipping Fee ($)</Label>
          <Input
            type="number"
            id="shippingFee"
            name="shippingFee"
            value={formData.shippingFee}
            onChange={handleInputChange}
            min="0"
            step="0.01"
          />
          {errors.shippingFee && (
            <ErrorMessage>{errors.shippingFee}</ErrorMessage>
          )}
        </div>

        <div>
          <Label htmlFor="discount">Discount ($)</Label>
          <Input
            type="number"
            id="discount"
            name="discount"
            value={formData.discount}
            onChange={handleInputChange}
            min="0"
            step="0.01"
          />
          {errors.discount && <ErrorMessage>{errors.discount}</ErrorMessage>}
        </div>

        <div>
          <Label htmlFor="filledBy">Filled By</Label>
          <Input
            type="text"
            id="filledBy"
            name="filledBy"
            value={formData.filledBy}
            onChange={handleInputChange}
            placeholder="Admin User"
            readOnly={true}
            disabled={true}
          />
        </div>
      </FormGroup>

      <FormGroup>
        <Label htmlFor="notes">Request Notes (Optional)</Label>
        <Input
          type="text"
          id="notes"
          name="notes"
          value={formData.notes}
          onChange={handleInputChange}
          placeholder="Any special instructions or notes for this request"
        />
      </FormGroup>

      <FormGroup>
        <Label htmlFor="clinical_notes">Clinical Notes</Label>
        <Input
          type="text"
          id="clinical_notes"
          name="clinical_notes"
          value={formData.clinical_notes}
          onChange={handleInputChange}
          placeholder="Clinical notes for the pharmacy"
        />
      </FormGroup>

      <OrderSummaryStyled>
        {formData.medicines.map((med, index) => (
          <SummaryRow key={`medicine-row-${index}`}>
            <span>
              {med.name || `Medicine ${index + 1}`} x {med.quantity || 1}:
            </span>
            <span>
              ${(parseFloat(med.price) ).toFixed(2)}
            </span>
          </SummaryRow>
        ))}

        <SummaryRow key="subtotal-row">
          <span>Subtotal:</span>
          <span>
            $
            {formData.medicines
              .reduce((sum, med) => {
                const price = parseFloat(med.price) ; 
                const quantity = parseInt(med.quantity, 10) || 1;
                return sum + price * quantity;
              }, 0)
              .toFixed(2)}
          </span>
        </SummaryRow>

        <SummaryRow key="shipping-row">
          <span>Shipping Fee:</span>
          <span>${parseFloat(formData.shippingFee || 0).toFixed(2)}</span>
        </SummaryRow>

        <SummaryRow key="discount-row">
          <span>Discount:</span>
          <span>-${parseFloat(formData.discount || 0).toFixed(2)}</span>
        </SummaryRow>

        <SummaryRow key="total-row" className="total">
          <span>Total:</span>
          <span>${calculateTotal()}</span>
        </SummaryRow>
      </OrderSummaryStyled>

      {errors.submit && <ErrorMessage>{errors.submit}</ErrorMessage>}

      <ActionButtons>
        <ActionButton
          type="button"
          secondary="true"
          onClick={() => navigate(-1)}
        >
          Cancel
        </ActionButton>

        <ActionButton type="submit" disabled={loading.submittingForm}>
          {loading.submittingForm ? (
            <ButtonContent>
              <LoadingSpinner />
              {editMode ? "Updating..." : "Creating..."}
            </ButtonContent>
          ) : editMode ? (
            "Update Order"
          ) : (
            "Create Order"
          )}
        </ActionButton>
      </ActionButtons>
    </FormSection>
  );
};

export default OrderSummary;